import { render } from "./ArtistListPublic.vue?vue&type=template&id=4a9fe14e&scoped=true"
import script from "./ArtistListPublic.vue?vue&type=script&lang=js"
export * from "./ArtistListPublic.vue?vue&type=script&lang=js"

import "./ArtistListPublic.vue?vue&type=style&index=0&id=4a9fe14e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9fe14e"]])

export default __exports__